<template>
  <div class="content">
    <div class="bg">
      <div class="filterline">
        <div class="date">
          <span class="sub">
            日期
          </span>
          <date-picker :format="'YYYY-MM-DD'" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="false" :shortcuts="false" confirm></date-picker>
        </div>
        <div class="btns">
          <p class="btn" @click="refresh()">
            <img src="@assets/img/resources/fresh.svg" alt="fresh">
            <span>刷新</span>
          </p>
          <p class="btn greenBtn" @click="exportRes()">
            <img src="@assets/img/resources/export.svg" alt="fresh">
            <span>导出图表</span>
          </p>
        </div>
      </div>
      <div class="status">
        <span class="sub">最小点击量</span>
        <div class="hits">
          <input type="number" v-model="minHit">
          <img src="@assets/img/filter/search.svg" alt="" class="search" @click="search()">
        </div>
      </div>
      <div class="line">
        <p></p>
      </div>
      <div v-show="isShow" class="chartSection" ref="chartSection">
        <div class="titleline">
          <div class="title">
            <i class="circle"></i>
            <span>报片数</span>
          </div>
        </div>
        <bar v-on:getCapture="getCapture" :data="barData" />
      </div>
      <div v-if="list && list.length > 0" class="titleline">
        <span class="order">序号</span>
        <span class="depart">部门</span>
        <span class="reporter">报片人</span>
        <span class="time w110">时间</span>
        <span class="title">数字报道</span>
        <span class="kktitle">看看标题</span>
        <span class="url">查看地址</span>
        <span class="video">视频</span>
        <span class="hit">点击率</span>
      </div>
      <empty :mTop="50" :msg="'暂无资源数据'" v-if="list && list.length === 0" />
      <div class="items" v-for="(l, i) in list" :key="i">
        <div class="item">
          <div class="order">
            {{l.id}}
          </div>
          <div class="depart">
            {{l.depart_title}}
          </div>
          <div class="reporter">
            {{l.user_name}}
          </div>
          <div class="time w110">
            {{l.raw_update_time}}
          </div>
          <div class="title">
            {{l.title}}
          </div>
          <div class="kktitle">
            {{l.knews_title}}
          </div>
          <div class="url" @click="to(l.url)">
            {{l.url}}
          </div>
          <div class="video">
            {{l.has_video}}
          </div>
          <div class="hit">
            {{l.count}}
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
      <resourceHandles ref="resourceHandles" />
    </div>
    <div class="footer" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <div class="btn" @click="exportTable()">下载表格</div>
    </div>
    <div class="capture" v-show="showCapture" @click.stop="showCapture = false">
      <a :href="captureImg" download="看看发布截图">
        <img class="img" :src="captureImg" alt="capture" title="点击保存">
      </a>
    </div>
  </div>
</template>

<script>
import pages from '@components/pages'
import DatePicker from 'vue2-datepicker'
import resourceHandles from '@components/resourceHandles'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import bar from '@components/bar'

export default {
  name: 'resources',
  components: {
    pages, DatePicker, resourceHandles, empty, bar
  },
  data() {
    return {
      page: {
        page_count: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      list: [],
      minHit: 0,
      datePicker: [],
      filters: [],
      filterOptions: {},
      barData: {},
      captureImg: '',
      showCapture: false,
      footLineGap: 230,
      isShow: false
    }
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n, o) {
        this.page.pageIndex = 1
        this.filterOptions['time_start'] = common.stampToTime(n[0])
        this.filterOptions['time_end'] = this.stampToTimeEnd(n[1])
        const start = +new Date(n[0])
        const end = +new Date(n[1])
        const gap = Math.ceil((end - start)/1000/60/60/24)
        if (gap > 30) {
          this.$toast('仅支持30天内的统计检索')
          return
        }

        this.getList()
      }
    }
  },
  methods: {
    exportTable() {
      // 导出表格
      const info = {
        time_start: '',
        time_end: '',
        view_num: this.minHit || 0,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys, this.filterOptions)
      const url = apis.data_kankan_expt

      common.exportRes(url, params)
    },
    stampToTimeEnd(s) {
      // 将时间戳转换为时间, 以23:59:59结束
      if (!s) {
        return ''
      }

      const year = s.getFullYear()
      const month = common.doubleDigit(s.getMonth() + 1)
      const day = common.doubleDigit(s.getDate())
      // const hour = common.doubleDigit(s.getHours())
      // const minute = common.doubleDigit(s.getMinutes())
      // const second = common.doubleDigit(s.getSeconds())

      return  `${year}-${month}-${day} 23:59:59`
    },
    getCapture(img) {
      this.captureImg = img
    },
    to(url) {
      window.open(url, true)
    },
    search() {
      console.log('search data')
      this.minHit = this.minHit || 0
      this.getList()
    },
    initYesterday() {
      const yesterday = this.getYesterday()

      this.datePicker = yesterday
    },
    getYesterday() {
      // 获取当日时间戳
      const today = +new Date()
      const yesterday = new Date(today-1000*60*60*24)
      const year = yesterday.getFullYear()
      const month = yesterday.getMonth() + 1
      const day = yesterday.getDate()
      const startSec = new Date(`${year}-${month}-${day} 00:00:00`)
      const endSec = new Date(`${year}-${month}-${day} 23:59:59`)

      return [startSec, endSec]
    },
    goItv(i) {
      // 跳转采访详情
      this.$router.push({
        path: '/interviewDetail',
        query: {
          r: i
        }
      })
    },
    getList() {
      //  获取列表数据
      const id = this.$route.params.id
      const info = {
        idstring: id,
        time_start: '',
        time_end: '',
        view_num: this.minHit || 0,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }
      Object.assign(info, this.filterOptions)

      common.myFetch(apis.data_kankan, info)
      .then((data) => {
        if (data) {
          console.log(12345, data)
          this.list = data.list
          this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', data.page.row_count - 0)
          if(data.departs.length > 0){
            this.isShow = true
          }else{
            this.isShow = false
          }
          this.generateBarData(data.departs)
          // this.$nextTick(() => {
          //   console.log(this.$refs.empty.childNodes)
          // })
        }
      })
    },
    generateBarData(data) {
      const categorys = data.map(i => i.depart_title)
      const value = data.map(i => i.num - 0)
      const containerWidth = this.$refs.chartSection.getBoundingClientRect().width
      const gridWidth = 0.9 * containerWidth
      const widthPerItem = gridWidth/(categorys.length)
      const xLabelRotate = widthPerItem > 130 ? 0 : 90
      console.log('width', widthPerItem, xLabelRotate)


      this.barData = {
        grid: {
          left: '5%',
          width: '90%',
          top: '20px',
          bottom: '130px'
        },
        xAxis: {
          type: 'category',
          axisTick: {show: false},
          axisLabel: {
            color: '#829191',
            verticalAlign: 'top',
            margin: 10,
            // rotate: xLabelRotate,
            formatter: function(v) {
              if (v.length > 8) {
                v = v.substring(0, 8) + '...'
              }

              if (xLabelRotate === 90) {
                return v.split('').join('\n')
              }

              return v
            }
          },
          data: categorys
        },
        yAxis: {
          axisLine: {show: false},
          axisTick: {show: false},
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            label: {
                normal: {
                    show: true,
                    position: 'top',
                    color: '#050f0f'
                }
            },
            data: value,
            animation: false
          }
        ]
      }
    },
    refresh() {
      // 刷新
      // window.location.reload()
      this.getList()
    },
    exportRes() {
      // 导出图表
      this.showCapture = true
    }
  },
  mounted() {
    this.footLineGap = this.footLineGap
    this.initYesterday()
  }
}
</script>

<style lang="less" src="@assets/css/data/kankan.less" scoped></style>
